// Hindi offer copy for the prerendered /pricing and /free-credits pages,
// the credit-usage FAQ and the Vectorizer allowance answer. `c` is the
// offer context from appRouteOfferCore.js (catalog prices, credit costs,
// free allowances), so no number is written here by hand.
export const APP_ROUTE_OFFER_COPY_HI = {
  pricing: (c) => ({
    title: 'मूल्य निर्धारण योजनाएँ',
    intro: [
      `Stocktag के मासिक क्रेडिट प्लान ${c.first.name} (${c.first.monthly} में ${c.first.credits} क्रेडिट) से ${c.last.name} (${c.last.monthly} में ${c.last.credits} क्रेडिट) तक हैं। सालाना बिलिंग पर ${c.discount}% बचत; एकमुश्त पैक में ${c.topUpPrice} में ${c.topUpCredits} क्रेडिट।`,
      `डिफ़ॉल्ट त्वरित विश्लेषण स्तर पर एक इमेज में ${c.fast} क्रेडिट लगता है। कीमतें USD में हैं; भुगतान से पहले चेकआउट आपकी स्थानीय मुद्रा में कुल राशि दिखाता है।`
    ],
    bullets: [
      `${c.planCount} मासिक क्रेडिट प्लान, हर महीने ${c.first.credits} से ${c.last.credits} क्रेडिट`,
      `सालाना बिलिंग पर ${c.discount}% की बचत, फिर भी हर महीने क्रेडिट जुड़ते हैं`,
      `एकमुश्त पैक: ${c.topUpPrice} में ${c.topUpCredits} क्रेडिट, जिनकी कोई समाप्ति नहीं`,
      `डिफ़ॉल्ट त्वरित विश्लेषण में प्रति इमेज ${c.fast} क्रेडिट से शुरू`
    ],
    links: [
      { href: '/metadata', label: 'Metadata Studio आज़माएँ' },
      { href: '/free-credits', label: 'मुफ़्त क्रेडिट पाएँ' },
      { href: '/help', label: 'मूल्य निर्धारण FAQ' }
    ],
    sections: [
      {
        title: 'मासिक क्रेडिट प्लान और कीमतें',
        paragraphs: [
          'प्लान इस बात से अलग होते हैं कि हर महीने कितने क्रेडिट जुड़ते हैं। सब्सक्रिप्शन क्रेडिट हर महीने रीफ़्रेश होते हैं; बिना इस्तेमाल हुए सब्सक्रिप्शन क्रेडिट अगले महीने में आगे नहीं बढ़ते।'
        ],
        bullets: c.plans.map((plan) => (plan.yearly
          ? `${plan.name}: हर महीने ${plan.credits} क्रेडिट, ${plan.monthly}/माह या सालाना ${plan.yearly} (${plan.yearlyPerMonth}/माह)`
          : `${plan.name}: हर महीने ${plan.credits} क्रेडिट, ${plan.monthly}/माह`))
      },
      {
        title: 'सालाना बिलिंग',
        paragraphs: [
          `सालाना भुगतान बारह मासिक भुगतानों से ${c.discount}% सस्ता है। बिल साल में एक बार बनता है, और प्लान के क्रेडिट फिर भी हर महीने जुड़ते हैं।`
        ]
      },
      {
        title: 'एकमुश्त क्रेडिट पैक',
        paragraphs: [
          `एक ही भुगतान में ${c.topUpPrice} में ${c.topUpCredits} क्रेडिट खरीदें। खरीदे गए क्रेडिट कभी समाप्त नहीं होते, बिना सब्सक्रिप्शन के भी काम करते हैं और सक्रिय प्लान के क्रेडिट में जुड़ जाते हैं।`
        ]
      },
      {
        title: 'एक क्रेडिट में क्या मिलता है',
        paragraphs: [
          'आप जो विश्लेषण स्तर चुनते हैं, उसके अनुसार हर फ़ाइल पर क्रेडिट कटते हैं। डिफ़ॉल्ट स्तर त्वरित विश्लेषण है।'
        ],
        bullets: [
          `त्वरित विश्लेषण: प्रति इमेज ${c.fast} क्रेडिट (डिफ़ॉल्ट)`,
          `मानक विश्लेषण: प्रति इमेज ${c.standard} क्रेडिट`,
          `गहन विश्लेषण: प्रति इमेज ${c.deep} क्रेडिट`,
          `वीडियो: हर ${c.videoSeconds} सेकंड पर 1 क्रेडिट, अगले पूरे ब्लॉक तक राउंड अप, प्रति क्लिप अधिकतम ${c.maxVideoSeconds} सेकंड`,
          `उदाहरण: ${c.example.name} प्लान के ${c.example.credits} मासिक क्रेडिट त्वरित विश्लेषण में लगभग ${c.example.fast}, मानक में ${c.example.standard} या गहन विश्लेषण में ${c.example.deep} इमेज के लिए काफ़ी हैं`
        ]
      }
    ],
    faq: [
      {
        q: 'Stocktag की कीमत क्या है?',
        a: `मासिक प्लान ${c.first.name} से शुरू होते हैं: ${c.first.monthly} में ${c.first.credits} क्रेडिट। सबसे बड़ा प्लान ${c.last.name} है: ${c.last.monthly} में ${c.last.credits} क्रेडिट। सालाना बिलिंग पर ${c.discount}% की बचत होती है, और ${c.topUpCredits} क्रेडिट वाले एकमुश्त पैक की कीमत ${c.topUpPrice} है। कीमतें USD में हैं; चेकआउट आपकी स्थानीय मुद्रा में कुल राशि दिखाता है।`
      },
      'creditUsage',
      {
        q: 'क्या क्रेडिट की समय-सीमा खत्म होती है?',
        a: 'सब्सक्रिप्शन क्रेडिट हर महीने रीफ़्रेश होते हैं और बिना इस्तेमाल हुए सब्सक्रिप्शन क्रेडिट अगले महीने में आगे नहीं बढ़ते। एकमुश्त पैक के क्रेडिट कभी समाप्त नहीं होते।'
      },
      {
        q: 'क्या मैं Stocktag मुफ़्त में आज़मा सकता हूँ?',
        a: `हाँ। योग्य नए खातों को ${c.welcome} मुफ़्त क्रेडिट मिलते हैं, और होमपेज का गेस्ट डेमो बिना साइन अप किए एक इमेज का सैंपल परिणाम बनाता है।`
      },
      {
        q: 'क्या सालाना प्लान में सारे क्रेडिट एक साथ मिलते हैं?',
        a: 'नहीं। सालाना प्लान का बिल साल में एक बार बनता है और प्लान के क्रेडिट हर महीने जुड़ते हैं।'
      }
    ]
  }),
  creditUsageFaq: (c) => ({
    q: 'एक इमेज में कितने क्रेडिट लगते हैं?',
    a: `डिफ़ॉल्ट त्वरित विश्लेषण में एक इमेज पर ${c.fast} क्रेडिट, मानक विश्लेषण में ${c.standard} क्रेडिट और गहन विश्लेषण में ${c.deep} क्रेडिट लगते हैं। वीडियो में हर ${c.videoSeconds} सेकंड पर 1 क्रेडिट लगता है।`
  }),
  freeCredits: (c) => ({
    title: 'मुफ़्त क्रेडिट',
    intro: [
      `योग्य नए खातों को ${c.welcome} मुफ़्त क्रेडिट और हर योग्य रेफ़रल पर ${c.referral} क्रेडिट मिलते हैं। अपनी स्टॉक इमेज पर टाइटल, विवरण और कीवर्ड आज़माएँ।`,
      `डिफ़ॉल्ट त्वरित विश्लेषण स्तर पर ${c.welcome} क्रेडिट ${c.welcomeImages} इमेज के लिए काफ़ी हैं। खाता बनाने से पहले नतीजा देखना चाहते हैं? होमपेज का गेस्ट डेमो बिना साइन अप किए एक इमेज प्रोसेस करता है।`
    ],
    bullets: [
      `योग्य नए खातों को ${c.welcome} मुफ़्त क्रेडिट`,
      `हर योग्य रेफ़रल पर ${c.referral} क्रेडिट`,
      'एक इमेज के लिए मुफ़्त गेस्ट डेमो, साइन अप की ज़रूरत नहीं',
      `Vectorizer: साइन इन करने पर रोज़ ${c.vectorFree} इमेज मुफ़्त`
    ],
    links: [
      { href: '/pricing', label: 'मूल्य निर्धारण विवरण' },
      { href: '/metadata', label: 'मेटाडेटा वर्कफ़्लो शुरू करें' },
      { href: '/help', label: 'क्रेडिट कैसे काम करते हैं' }
    ],
    sections: [
      {
        title: 'वेलकम क्रेडिट कैसे काम करते हैं',
        paragraphs: [
          `खाता बनाएँ और साइनअप जाँच पूरी करें। योग्य नए खातों को ${c.welcome} क्रेडिट मिलते हैं, जो डिफ़ॉल्ट त्वरित विश्लेषण में ${c.welcomeImages} इमेज के लिए काफ़ी हैं।`
        ],
        bullets: [
          'Metadata Studio में टाइटल, विवरण और कीवर्ड बनाने के लिए इस्तेमाल करें',
          `त्वरित विश्लेषण में प्रति इमेज ${c.fast}, मानक में ${c.standard} और गहन विश्लेषण में ${c.deep} क्रेडिट लगते हैं`,
          'नतीजों की समीक्षा करें और अपने मार्केटप्लेस के लिए CSV या XMP एक्सपोर्ट करें'
        ]
      },
      {
        title: 'रेफ़र करके क्रेडिट कमाएँ',
        paragraphs: [
          `इस पेज से अपना निजी रेफ़रल लिंक शेयर करें। जब कोई उस लिंक से खाता बनाता है और ज़रूरी जाँच पास करता है, तो आपको अपने-आप ${c.referral} क्रेडिट मिल जाते हैं।`
        ],
        bullets: [
          'मुफ़्त क्रेडिट पेज से अपना लिंक कॉपी या शेयर करें',
          'कुल रेफ़रल और कमाए गए क्रेडिट देखें',
          'हर योग्य नए खाते के लिए इनाम सिर्फ़ एक बार मिलता है'
        ]
      },
      {
        title: 'टेस्ट करने के सबसे अच्छे तरीके',
        paragraphs: [
          'अपने काम का प्रतिनिधि बैच चलाएँ और कीवर्ड क्रम, विवरण और एक्सपोर्ट फ़ॉर्मेट की समीक्षा करें, ताकि पता चले कि वर्कफ़्लो आपके पोर्टफ़ोलियो के लिए कितना सही है।'
        ],
        bullets: [
          'कई मार्केटप्लेस पर टेस्ट करें',
          'सर्च इंटेंट के हिसाब से कीवर्ड सेट की तुलना करें',
          'CSV या XMP एक्सपोर्ट जाँचें'
        ]
      }
    ],
    faq: [
      {
        q: 'मुफ़्त क्रेडिट कैसे मिलते हैं?',
        a: `Stocktag खाता बनाएँ। योग्य नए खातों को साइनअप के बाद ${c.welcome} क्रेडिट मिलते हैं, और हर योग्य रेफ़रल पर आपको ${c.referral} क्रेडिट मिलते हैं।`
      },
      {
        q: 'क्या साइन अप किए बिना Stocktag आज़मा सकते हैं?',
        a: 'हाँ। होमपेज का गेस्ट डेमो बिना खाते के, हर 24 घंटे में एक बार, एक इमेज का सैंपल मेटाडेटा परिणाम बनाता है। परिणाम बनाने के लिए इमेज Stocktag की गेस्ट मेटाडेटा सेवा को भेजी जाती है।'
      },
      {
        q: 'मुफ़्त क्रेडिट खत्म होने पर क्या करें?',
        a: `${c.first.monthly} में ${c.first.credits} क्रेडिट से शुरू होने वाला मासिक प्लान चुनें, या ${c.topUpPrice} में ${c.topUpCredits} क्रेडिट का एकमुश्त पैक खरीदें। एकमुश्त क्रेडिट कभी समाप्त नहीं होते।`
      },
      'creditUsage'
    ]
  }),
  vectorizerAllowance: (c) => `हाँ। आप एक फ़ाइल या पूरा बैच बदल सकते हैं। साइन इन किए खाते रोज़ ${c.vectorFree} इमेज मुफ़्त में वेक्टराइज़ कर सकते हैं; इसके बाद हर अतिरिक्त इमेज पर ${c.vectorPaid} क्रेडिट लगता है।`
};

export default APP_ROUTE_OFFER_COPY_HI;
